import type { ReactElement } from 'react'

import ExploreHeaderDefault from './ExploreHeaderDefault'
import ExploreHeaderTutor from './ExploreHeaderTutor'

export default function ExploreHeader({ type = 'default' }: { type?: string }): ReactElement {
  return type === 'tutor' ? <ExploreHeaderTutor /> : <ExploreHeaderDefault />
}
